module.exports = __webpack_public_path__ + "static/media/search_close.647d7d0a.svg";